import { RoleBaseDesignThemeSizeConfig } from './types';

const large: RoleBaseDesignThemeSizeConfig = {
  roleBaseDesign: {},
};

export default large;
